export const team = [
  {
    name: "Shubam Godeniya ",
    role: "Business Development Executive",
    img: "/ceo.png",
    large: true,
  },
  {
    name: "Hariom Ruhela",
    role: "Frontend Developer",
    img: "/frontend.png",
  },
  {
    name: "Darshan Barjaure",
    role: "UI/UX Designer",
    img: "/UIdesinger.png",
  },
  {
    name: "Praveen Makwana",
    role: "Resarch Analyst",
    img: "/image.png",
  },
];